import apiRoutes from "../../utils/constants/apiRoutes";
import ApiService from "../apiService";
import handleApiCall from "../handleApi";

export const getLoggedUserService = async () =>
  handleApiCall(() => ApiService.get(apiRoutes.loggedInUser));
